/**
 * Where a video's frames come from. `resolveVideoSource` reads a record
 * carrying none as YouTube, and refuses one that also holds a Gumlet asset ID.
 */
export enum VideoPlaybackProvider {
  YouTube = 'youtube',
  Gumlet = 'gumlet',
}
